import { render, staticRenderFns } from "./TextCreationComponent.vue?vue&type=template&id=2afd82fa&scoped=true&"
import script from "./TextCreationComponent.vue?vue&type=script&lang=js&"
export * from "./TextCreationComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextCreationComponent.vue?vue&type=style&index=0&id=2afd82fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd82fa",
  null
  
)

export default component.exports